var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 7.25008V16.3334C17.3335 16.8196 17.1403 17.286 16.7965 17.6298C16.4527 17.9736 15.9864 18.1667 15.5002 18.1667H4.50016C4.01393 18.1667 3.54762 17.9736 3.2038 17.6298C2.85998 17.286 2.66683 16.8196 2.66683 16.3334V7.25008M17.3335 7.25008H2.66683M17.3335 7.25008C17.8197 7.25008 18.286 7.05693 18.6299 6.71311C18.9737 6.36929 19.1668 5.90298 19.1668 5.41675V4.50008C19.1668 4.01385 18.9737 3.54754 18.6299 3.20372C18.286 2.8599 17.8197 2.66675 17.3335 2.66675H2.66683C2.1806 2.66675 1.71428 2.8599 1.37047 3.20372C1.02665 3.54754 0.833496 4.01385 0.833496 4.50008V5.41675C0.833496 5.90298 1.02665 6.36929 1.37047 6.71311C1.71428 7.05693 2.1806 7.25008 2.66683 7.25008M7.3335 10.9167H12.6668",
    stroke: "#0e0333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.e752da88e50fdab32da44cdf764762a2.svg";
export { ForwardRef as ReactComponent };